module.exports = __webpack_public_path__ + "img/6.5cef12d7.jpg";